export default __webpack_public_path__ + "static/SR USA - Continuing Guarantee - Statement-bf40a3a9c1111c1c3aced445ef681fc7.pdf";